const getBreakCode = (code) => {
  switch (code) {
    case 'ISTIRAHAT_MAKAN':
      return 'mealBreak';
    case 'SHOLAT':
      return 'prayBreak';
    case 'TOILET':
      return 'toiletBreak';
    case 'BANTU_REKAN':
      return 'helpPartner';
    default:
      break;
  }
};

export default getBreakCode;
